export default __webpack_public_path__ + "images/27df7406615440682922585f92007ac6.png";